import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import { ViewDetailForm } from 'entities/user/components/view-detail-form'

import { IProfileTypes } from 'shared/constants'
import { ButtonContinue } from 'shared/ui/bottom-continue'

import s from './styles.module.scss'

const ViewProfileDetail = () => {
  const { type } = useParams()

  const { t } = useTranslation()

  const navigate = useNavigate()

  const onNavigatePage = () => {
    navigate(RoutingPaths.profile.edit.path(type))
  }

  return (
    <>
      <ViewDetailForm type={type as IProfileTypes} />

      <ButtonContinue onClick={onNavigatePage}>
        <span className={clsx(s.edit, 'semi-bold-17')}>{t('edit')}</span>
      </ButtonContinue>
    </>
  )
}

export default ViewProfileDetail
